import React from 'react'
import { useIntl } from 'react-intl'
import { useRecoilValue } from 'recoil'
import moment from 'moment-timezone'

import {
  Flex,
  FlexItem,
  Title,
  Text,
  TEXT_VARIANT_LIGHT
} from 'mailup-web-components'
import IconEstimatedTime from 'Img/IconEstimatedTime'

import { sendingsState } from '../recoil/state/sendings'

const TimeStatus = () => {
  const intl = useIntl()
  const { estimated } = useRecoilValue(sendingsState)

  const formatTime = () => {
    const secondsTime = moment.duration(estimated, 'seconds')
    const d = secondsTime.days()
    const h = secondsTime.hours()
    const m = secondsTime.minutes()
    const s = secondsTime.seconds()

    return `${intl.formatNumber(d)}d ${String(h).padStart(2, '0')}h ${String(
      m
    ).padStart(2, '0')}m ${String(s).padStart(2, '0')}s`
  }

  return (
    <Flex alignItems='flex-start'>
      <FlexItem margin='0 8px 0 0'>
        <IconEstimatedTime />
      </FlexItem>
      <FlexItem margin='0 16px'>
        <Title>{formatTime()}</Title>
        <Text variant={TEXT_VARIANT_LIGHT}>
          {intl.formatMessage({
            id: 'Load.SmtpPlusV2SendQueue.EstimatedTimeProcessQueue'
          })}
        </Text>
      </FlexItem>
    </Flex>
  )
}

export default TimeStatus
